const herb = {
  type: '',
  specie: '',
  area: null
}

const hcv = {
  hcv: '',
  dead_wood: null,
  habitat: null,
  endangered_type: '',
  endangered_specie: ''
}

const member = {
  name: '',
  surname: ''
}

const localization = {
  municipality: '',
  administrative_limit: '',
  local_name: '',
  alfis_code: '',
  sub_economy: '',
  parcel: null,
  sub_parcel: '',
  dt_update: '',
  plotType: '01',
  // site description
  exposition: '',
  relief: '',
  rock_formation: '',
  litter_depth: '',
  humus_depth: '',
  land_cover: '',
  // management
  main_function: '',
  specific_function: '',
  specific_function_detail: '',
  // forest stand
  homogeneity: '',
  manag_intensity: '',
  // forest stand -> development stage
  develop_stage_high_forest: '',
  develop_stage_coppice: '',
  develop_stage_shrub: '',
  // forest stand -> origin
  forest_origin_natural: '',
  forest_origin_year: null,
  forest_origin_detail: '',
  // forest stand -> regeneration
  regeneration_origin_natural: '',
  regeneration_origin_year: null,
  regeneration_mean_h: null,
  regeneration_mean_d: null,
  regeneration_seedling_nr: null,
  regeneration_species1_std2: '',
  regeneration_species2_std2: '',
  // health
  health_damage_type: '',
  health_damage_intensity: '',
  health_damage_area: null,
  health_main_reason: '',
  health_dead_tree: null,
  // biodiversity
  bio_actual_vegetation_anx11: '',
  bio_potential_vegetation_anx11: '',
  bio_naturality: '',
  bio_biodiversity_risk: '',
  bio_biotope_std5: '',
  bio_hcv: [{ ...hcv }],
  // herbs
  herbs: [{ ...herb }]
}

const plot = {
  plot_num: null,
  event_num: null,
  plot_sample: '',
  slope: '',
  elevation: null,
  plot_type: '',
  event_type: '',
  coords: {
    latitude: 0,
    longitude: 0
  },
  note: ''
}

export { member, localization, plot, herb, hcv }
